
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { DocumentLoading_State } from "../../shared/enums";


import CircleLoader from "../Loader/CircleLoader/CircleLoader";
import './PdfViewer.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export interface PreviewProps {
    base64String?: string | undefined
    file?: File | Blob;
    // initialLoading deve essere true quando si vuole evitare di vedere il NoData finchè 
    // non arriva la response che restituisce la stringa base64
    // (es. in protocolViewer finchè non viene caricato la stringa base64 del documento)
    initialLoading: boolean
    onLoadDocumentError?: () => void
    onLoadDocumentSuccess?: (pdf: any) => void
}

type Props = PreviewProps;


const PdfViewer: React.FunctionComponent<Props> = props => {
    const [fileSource, setFileSource] = useState<string | { data: Uint8Array } | undefined>(undefined);
    const [pageScale, setPageScale] = useState(1);
    const [numPages, setNumPages] = useState<number | null>(null);
    const [documentLoadingState, setDocumentLoading] = useState<DocumentLoading_State>(DocumentLoading_State.Loading);

    useEffect(() => {
        const load = async () => {
            // Resetta il conteggio pagine prima di caricare il nuovo documento,
            // evitando che React tenti di renderizzare le pagine del documento precedente.
            setNumPages(null);

            if (props.file) {
                setDocumentLoading(DocumentLoading_State.Loading);
                const buffer = await props.file.arrayBuffer();
                setFileSource({ data: new Uint8Array(buffer) });
                return;
            }

            if (props.base64String) {
                setDocumentLoading(DocumentLoading_State.Loading);
                try {
                    const byteCharacters = atob(props.base64String);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    setFileSource({ data: byteArray });
                } catch (error) {
                    console.error(error);
                    setDocumentLoading(DocumentLoading_State.LoadError);
                }
                return;
            }

            if (props.initialLoading) {
                setDocumentLoading(DocumentLoading_State.Loading);
                return;
            }

            setDocumentLoading(DocumentLoading_State.NoData);
            setFileSource(undefined);
        };

        load();
    }, [props.file, props.base64String, props.initialLoading]);

    function onLoadDocumentSuccess(pdf) {
        setNumPages(pdf.numPages);
        setDocumentLoading(DocumentLoading_State.LoadSuccess);

        if (props.onLoadDocumentSuccess)
            props.onLoadDocumentSuccess(pdf);

    }
    function onLoadDocumentError(error) {
        console.error(error.message);
        setDocumentLoading(DocumentLoading_State.LoadError);
        if (props.onLoadDocumentError)
            props.onLoadDocumentError();

    }

    const onPageLoad = (page) => {
        if (page.pageNumber === 1) {
            /// calcolo lo scale del documento
            let pdfContainerWidth = document.getElementsByClassName('react-pdf__Page')[0]?.clientWidth;
            let scale = pdfContainerWidth / page.originalWidth
            scale = scale < 1.5 ? scale : 1.5;
            setPageScale(scale);
        }
    }


    return (
        <div style={{ position: 'relative', height: '100%', minHeight: '300px' }}>
            <CircleLoader loaderClass='loader-large' loading={documentLoadingState === DocumentLoading_State.Loading} />

            {(documentLoadingState !== DocumentLoading_State.LoadError) &&
                <Document
                    file={fileSource}
                    onLoadSuccess={onLoadDocumentSuccess}
                    onLoadError={onLoadDocumentError}
                >
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            onLoadSuccess={onPageLoad}
                            scale={pageScale}
                        />
                    ))}
                </Document>
            }
            {(documentLoadingState === DocumentLoading_State.LoadError) &&
                <div className="preview-document">
                    <div className="preview-document-container">
                        <FontAwesomeIcon className="preview-document-icon" icon={{ prefix: 'far', iconName: 'eye-slash' }} />
                    </div>
                    <h2 className="preview-document-description">Anteprima non disponibile</h2>
                </div >
            }
            {(documentLoadingState === DocumentLoading_State.NoData) &&
                <div className="preview-document">
                    <div className="preview-document-container">
                        <FontAwesomeIcon className="preview-document-icon" icon={{ prefix: 'far', iconName: 'file' }} />
                    </div>
                    <h2 className="preview-document-description">Nessun documento selezionato</h2>
                </div >
            }

        </div>
    );
}

export default PdfViewer;